import { render } from "./ProjectDocumentsBuilder.vue?vue&type=template&id=5360ff04"
import script from "./ProjectDocumentsBuilder.vue?vue&type=script&lang=js"
export * from "./ProjectDocumentsBuilder.vue?vue&type=script&lang=js"

import "./ProjectDocumentsBuilder.vue?vue&type=style&index=0&id=5360ff04&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__